import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertController, IonModal, LoadingController, ToastController } from '@ionic/angular';
import { NaploService } from '../naplo.service';
import { DataService } from '../../data.service';

// NAPLO – e-Önkormányzat (ASP/OHP adófolyószámla). Ügyfelenként beállítható, mely önkormányzatokat
// szinkronizáljuk (törzslistából), központi ügyfélkapu+ fiókkal. A szinkron lehozza az adófolyószámla
// egyenleget, tételeket, befizetési számlaszámokat és a PDF kivonatot.
@Component({
  selector: 'app-naplo-eonkormanyzat',
  templateUrl: './eonkormanyzat.component.html',
  styleUrls: ['../naplo-shared.scss', './eonkormanyzat.component.scss'],
})
export class EonkormanyzatComponent implements OnInit {
  @ViewChild('hozzarModal') hozzarModal: IonModal;
  get aktiv() { return this.naplo.aktiv; }
  fiokok: any[] = [];
  hozzarendelt: any[] = [];
  egyenlegek: any[] = [];
  torzsTalalat: any[] = [];
  szerk: any = null;

  constructor(private naplo: NaploService, private toast: ToastController,
    private alert: AlertController, private loadingCtrl: LoadingController, private data: DataService) {}

  async ngOnInit() {
    await this.naplo.init();
    await this.betoltCaptcha();
    if (!this.aktiv.ugyfelId) return;
    await Promise.all([this.betoltFiokok(), this.betoltHozzar(), this.betoltEgyenleg()]);
  }

  async betoltFiokok() {
    try { this.fiokok = await this.naplo.get('/ugyfelkapu/fiokok/' + this.aktiv.intezmeny); } catch { this.fiokok = []; }
  }
  async betoltHozzar() {
    try { this.hozzarendelt = await this.naplo.get('/onkormanyzat/ugyfel/' + this.aktiv.ugyfelId); }
    catch { this.hiba('Nem sikerült betölteni a hozzárendelt önkormányzatokat.'); }
  }
  async betoltEgyenleg() {
    try { this.egyenlegek = await this.naplo.get('/onkormanyzat/egyenleg/' + this.aktiv.ugyfelId); } catch { this.egyenlegek = []; }
  }

  // ---- Hozzárendelés (törzslistából) ----
  ujHozzar() { this.szerk = { onkormanyzat_id: null, onkormanyzat_nev: '', fiok_id: this.fiokok[0]?.id || null, adoazonosito: '', szerepkor: null, szerepkor_nev: '' }; this.torzsTalalat = []; this.hozzarModal.present(); }
  szerkeszt(h: any) { this.szerk = { id: h.id, onkormanyzat_id: h.onkormanyzat_id, onkormanyzat_nev: h.onkormanyzat_nev, fiok_id: h.fiok_id, adoazonosito: h.adoazonosito || '', szerepkor: h.szerepkor || null, szerepkor_nev: h.szerepkor_nev || '' }; this.torzsTalalat = []; this.hozzarModal.present(); }

  // Adózó típusának + nevének lekérése a NAV-tól adószám alapján (a portál-szerepkörhöz).
  async tipusLekeres() {
    const ad = String(this.szerk?.adoazonosito || '').replace(/\D/g, '').slice(0, 8);
    if (ad.length !== 8) return this.hiba('A típus automatikus felismeréséhez 8 jegyű adószám (törzsszám) kell.');
    try {
      const t: any = await this.naplo.get('/osa/taxpayer/' + this.aktiv.ugyfelId + '?adoszam=' + ad);
      if (t?.tipus) this.szerk.szerepkor = t.tipus;
      if (t?.nev && !this.szerk.szerepkor_nev) this.szerk.szerepkor_nev = t.nev;
      const cimke: any = { ceg: 'Cég/szervezet', egyeni: 'Egyéni vállalkozó', maganszemely: 'Magánszemély' };
      this.ok('NAV szerint: ' + (cimke[t?.tipus] || 'ismeretlen típus') + (t?.nev ? ' – ' + t.nev : ''));
    } catch (e: any) { this.hiba(e?.error?.error || 'A NAV-lekérdezés nem sikerült.'); }
  }

  async torzsKeres(ev: any) {
    const q = String(ev?.detail?.value || ev?.target?.value || '').trim();
    try { this.torzsTalalat = await this.naplo.get('/onkormanyzat/torzs' + (q ? '?q=' + encodeURIComponent(q) : '')); } catch { this.torzsTalalat = []; }
  }
  torzsValaszt(t: any) { this.szerk.onkormanyzat_id = t.id; this.szerk.onkormanyzat_nev = t.nev + (t.hivatalos_nev ? ' – ' + t.hivatalos_nev : (t.megye ? ' (' + t.megye + ')' : '')); this.torzsTalalat = []; }

  async mentHozzar() {
    if (!this.szerk?.onkormanyzat_id) return this.hiba('Válassz önkormányzatot a listából.');
    try {
      if (this.szerk.id) await this.naplo.put('/onkormanyzat/ugyfel/' + this.szerk.id, { fiok_id: this.szerk.fiok_id, adoazonosito: this.szerk.adoazonosito, szerepkor: this.szerk.szerepkor, szerepkor_nev: this.szerk.szerepkor_nev, aktiv: 1 });
      else await this.naplo.post('/onkormanyzat/ugyfel', { ugyfel_id: this.aktiv.ugyfelId, onkormanyzat_id: this.szerk.onkormanyzat_id, fiok_id: this.szerk.fiok_id, adoazonosito: this.szerk.adoazonosito, szerepkor: this.szerk.szerepkor, szerepkor_nev: this.szerk.szerepkor_nev });
      this.hozzarModal.dismiss(); await this.betoltHozzar(); this.ok('Mentve.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }

  async torol(h: any) {
    const a = await this.alert.create({ header: 'Törlés', message: h.onkormanyzat_nev + ' eltávolítása?', buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Törlés', role: 'destructive' }] });
    await a.present(); const { role } = await a.onDidDismiss(); if (role !== 'destructive') return;
    try { await this.naplo.del('/onkormanyzat/ugyfel/' + h.id); await this.betoltHozzar(); await this.betoltEgyenleg(); } catch { this.hiba('Nem sikerült törölni.'); }
  }

  // ---- Új önkormányzat felvétele a törzsbe (ha nincs a listában) ----
  async ujTorzs() {
    const a = await this.alert.create({
      header: 'Önkormányzat felvétele a törzsbe', inputs: [
        { name: 'nev', type: 'text', placeholder: 'Önkormányzat / település neve' },
        { name: 'megye', type: 'text', placeholder: 'Megye (opcionális)' },
      ], buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Felvesz', role: 'ok' }],
    });
    await a.present(); const { role, data } = await a.onDidDismiss();
    if (role !== 'ok' || !data?.values?.nev) return;
    try { const r: any = await this.naplo.post('/onkormanyzat/torzs', data.values); this.torzsValaszt({ id: r.id, nev: data.values.nev, megye: data.values.megye }); this.ok('Felvéve a törzsbe.'); }
    catch { this.hiba('Nem sikerült felvenni.'); }
  }

  // ---- Captcha-solver beállítás (2captcha / CapSolver) ----
  //  A kulcsot egyszer állítja be a könyvelő, utána csak foglalja a helyet a képernyőn: alapból
  //  rejtve van, a fejléc „Solver" gombja hozza elő (cseréhez, hibakereséshez).
  captchaMutat = false;
  captcha: any = { provider: '2captcha', hasKey: false, apiKey: '' };
  async betoltCaptcha() {
    try { const c: any = await this.naplo.get('/onkormanyzat/captcha-beallitas'); this.captcha = { provider: c?.provider || '2captcha', hasKey: !!c?.hasKey, apiKey: '' }; } catch {}
  }
  async captchaMent() {
    try { await this.naplo.put('/onkormanyzat/captcha-beallitas', { provider: this.captcha.provider, apiKey: this.captcha.apiKey || undefined }); this.captcha.apiKey = ''; await this.betoltCaptcha(); this.ok('Captcha-solver beállítás mentve.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }

  // ---- Szinkron: a más-nevében szerepkórváltás Turnstile-ja miatt a felhasználó VALÓDI böngészőjében futó
  //      Cronomit userscript végzi (OHP-n). A gomb megnyitja az OHP-t auto-start jellel; a userscript automatikusan
  //      belép + kitölt, a felhasználó megnyomja a Szerepkórváltás gombot, és a kivonat ide visszaérkezik. ----
  async szinkron(h?: any) {
    // A lapot AZONNAL nyitjuk (a kattintás pillanatában), különben a böngésző előugró ablakként
    // letiltaná – a jegy lekérése után csak a címét állítjuk be.
    const lap = window.open('about:blank', 'cronom_ohp');
    // A userscript a jeggyel hívja a kiszolgálót: az OHP oldalán nincs bejelentkezési tokenünk,
    // jegy nélkül pedig a KAÜ-fiók adatait adó végpontok zárva vannak.
    let jegy = '';
    try {
      const r: any = await this.naplo.post('/onkormanyzat/userscript-jegy', { intezmeny: this.aktiv.intezmeny });
      jegy = r?.jegy || '';
    } catch (e: any) {
      lap?.close();
      this.hiba(e?.error?.error || 'Nem sikerült elindítani a szinkront (jegy).');
      return;
    }
    // A userscript a SAJÁT kiszolgálónkat hívja (nem bedrótozott dev címet): átadjuk a jelen
    // installáció origóját. Weben ez a lap origója (ide mennek a relatív /api hívások is), az
    // asztali programban a helyi kiszolgáló – a userscript ezt tárolja és a KAÜ/OHP lapokon is ezt használja.
    const url = 'https://ohp-20.asp.lgov.hu/nyitolap#cronom-autostart' + (h ? '=' + h.id : '')
      + '&jegy=' + encodeURIComponent(jegy)
      + '&backend=' + encodeURIComponent(window.location.origin);
    if (lap) lap.location.href = url; else window.open(url, 'cronom_ohp');
    this.ok('Megnyitottam az OHP-t — a Cronomit userscript automatikusan elindul. Amikor kéri, nyomd meg a Szerepkórváltás gombot. A kivonat utána ide megérkezik.');
    if (!(this as any)._focusKotve) {
      (this as any)._focusKotve = true;
      window.addEventListener('focus', () => { this.betoltHozzar(); this.betoltEgyenleg(); });
    }
  }

  osszeg(sorok: any[], mezo: string) { return (sorok || []).reduce((s, e) => s + (Number(e?.[mezo]) || 0), 0); }
  pdf(h: any) { if (h.pdf_object) this.data.megnyitFajl('/api/naplo/onkormanyzat/pdf/' + h.id, 'Adófolyószámla kivonat'); }
  fiokNev(id: string) { return this.fiokok.find(f => f.id === id)?.cimke || '—'; }

  private async ok(m: string) { (await this.toast.create({ message: m, duration: 1600, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 2600, color: 'danger' })).present(); }
}
